module.exports = __webpack_public_path__ + "static/media/ya-message-logo.fae25e3b.svg";